module.exports = {
      id: "v-plus-logo-usage",
      viewBox: "0 0 165.404 72.698",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#v-plus-logo",
      toString: function () {
        return this.url;
      }
    }